type QueryKey = readonly unknown[];

export const baseKey = <const Q extends QueryKey>(q: Q) => {
  return new BaseKey(q);
};

export class BaseKey<const Q extends QueryKey = QueryKey> {
  public readonly mutationKey: Q;
  public readonly queryKey: Q;
  constructor(queryKey: Q) {
    this.mutationKey = queryKey;
    this.queryKey = queryKey;
  }

  extend = <const Q2 extends QueryKey>(q2: Q2) => {
    return new BaseKey([...this.queryKey, ...q2]);
  };

  extendClass = <const Q2 extends BaseKey>(q2: Q2) => {
    return new BaseKey([...this.queryKey, ...q2.queryKey]);
  };
}
